import { render, staticRenderFns } from "./TransferView.vue?vue&type=template&id=fbfbddea&scoped=true&"
import script from "./TransferView.vue?vue&type=script&lang=js&"
export * from "./TransferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfbddea",
  null
  
)

export default component.exports